import type { IOnboardingStep } from '../../types/IOnboardingStep'

/** Помечает группу шагов набором открытых областей */
export function withScopes(scopes: string[], steps: IOnboardingStep[]): IOnboardingStep[] {
  return steps.map(step => ({ ...step, scopes }))
}
